import { Injectable } from '@angular/core';
// import { environment } from '../../environments/environment';
import { BehaviorSubject, catchError, map, Observable, tap, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { IProjectFromWeb, Project } from '../models/models.lib';
import { ApiService } from '../api/api.service';
import { FormModes } from '../common/constants.lib';
import { SettingsService } from '../settings/settings.service';
import { LoggerService } from '../shared/logger.service';
import { Settings } from '../common/obj.lib';

// const { apiUrl } = environment;

export abstract class CasiProjectsService extends BehaviorSubject<Array<any>> {
  public loading: boolean = false;
  private settings: Settings = this.settingsService.getSettings();

  constructor(
    private http: HttpClient,
    private settingsService: SettingsService
  ) {
    super([]);
  }

  public query(): void {
    this.fetch().subscribe((x) => {
      return super.next(x);
    });
  }

  protected fetch(): Observable<Project[]> {
    this.loading = true;
    this.settings = this.settingsService.getSettings();
    return this.http.get(encodeURI(`${this.settings.apiUrl}/project`))
      .pipe(
        map((response: any, i) => {
          return <IProjectFromWeb[]>response;
        }),
        map(r => r.map(x => Project.create(x))),
        map((data) => {
          data.sort((a, b) => {
            return a.project_name! < b.project_name! ? -1 : 1;
          });
          // console.log(`project:service:fetch:data:sorted: `, data);
          return data;
        }),
        tap(() => (this.loading = false))
      )
  }
}

@Injectable({
  providedIn: 'root'
})
export class ProjectsService extends CasiProjectsService {

  constructor(
    http: HttpClient,
    private settingService: SettingsService,
    private apiService: ApiService,
    private logger: LoggerService
  ) {
    super(http, settingService);
  }

  get(): Promise<Project[]> {
    return new Promise((resolve, reject) => {
      // this.logger.debug(`get...`);
      this.loading = true;
      this.apiService.getHttpCall('project', 'get')
        .pipe(map((resp: any, i) => {
          return <IProjectFromWeb[]>resp;
        }),
          map(r => r.map(x => Project.create(x))),
          map((data) => {
            data.sort((a, b) => {
              return a.project_name! < b.project_name! ? -1 : 1;
            });
            return data;
          }),
          tap(() => (this.loading = false)),
          catchError(errRes => {
            return throwError(() => errRes)
          })
        )
        .subscribe({
          next: resData => {
            // this.logger.debug(`get:subscribe:resData`, resData);
            return resolve(resData);
          },
          error: err => {
            this.logger.error(`get:error: `, err.message);
            return reject(err);
          }
        })
    });
  }
  // get() {
  // return this.apiService.getHttpCallAsPromise('project', 'get');
  // .subscribe(response => )

  getById(id: number): Promise<any> {
    return this.apiService.getHttpCallAsPromise(`project/${id}`, 'getById');
  }

  add(p: any): Promise<any> {
    return this.apiService.postHttpCallAsPromise('project', p, 'add');
  }

  update(p: any): Promise<any> {
    return this.apiService.putHttpCallAsPromise(`project/${p.id}`, p, 'update');
  }

  destroy(id: number): Promise<any> {
    return this.apiService.deleteHttpCallAsPromise(`project/${id}`, 'destroy');
  }

  addEdit(p: any, formMode: FormModes): Promise<any> {
    if (formMode === FormModes.NEW) {
      return this.add(p);
    } else {
      return this.update(p);
    }
  }

}
